import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import React__default, { useMemo } from 'react';
import { MenuDownIcon } from '@iris/react-icons/MenuDownIcon';
import { Header, Trigger } from '@radix-ui/react-accordion';
import accordionStyles from './Accordion.styles.esm.js';
import { useAccordionContext } from './AccordionContext.esm.js';
import { cn } from '../../utils/cn.esm.js';

// Create AccordionTrigger subcomponent
const AccordionTrigger = React__default.forwardRef((_a, ref) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    const { variant, inverse, additionalLabel } = useAccordionContext();
    const hasAdditionalLabel = !!additionalLabel;
    const { trigger, icon, iconContainer, triggerContent, additionalLabel: additionalLabelClass, } = useMemo(() => accordionStyles({
        variant,
        inverse,
        hasAdditionalLabel,
    }), [variant, inverse, hasAdditionalLabel]);
    const triggerProps = Object.assign({ ref, className: cn(trigger(), className) }, props);
    const iconWithContainer = (jsx("div", { className: iconContainer(), children: jsx(MenuDownIcon, { className: icon(), "aria-hidden": true }) }));
    return (jsx(Header, { asChild: true, children: !additionalLabel ? (jsxs(Trigger, Object.assign({}, triggerProps, { children: [jsx("div", { className: triggerContent(), children: children }), iconWithContainer] }))) : (jsxs(Trigger, Object.assign({}, triggerProps, { children: [jsxs("div", { className: triggerContent(), children: [iconWithContainer, children] }), jsx("span", { className: additionalLabelClass(), children: additionalLabel })] }))) }));
});

export { AccordionTrigger };
